export default {"src":"/_next/static/media/icon_footer_menu_tungsten.a4475792.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};